import { Binder, BinderPropertyDescriptor, IBinding } from "../../../binding/binding";
import { BindingPrototype } from "../../prototype/bindingPrototype";
import { HtmlBridgePrototype } from "../../prototype/htmlBridgePrototype";
import { View } from "../../../uiPatterns/mvvm/view";
import { ViewModel } from "../../../uiPatterns/mvvm/viewmodel";
import { HtmlBridge } from "../htmlBridge";

export class EventHtmlBridgePrototype extends HtmlBridgePrototype{

    public eventName:string;
    
    createInternal(view: View<ViewModel>, node: Node): HtmlBridge {
        let bridge = new EventHtmlBridge(this);
        bridge.create(view,node);
        return bridge;
    }
}

class EventHtmlBridge extends HtmlBridge{
    
    private eventName:string;
    private element:Element;
    private bindingPrototype : BindingPrototype;
    private eventListenner;
    private codeBehind : any;
    constructor(prototype:EventHtmlBridgePrototype) {
        super();
        this.bindingPrototype = prototype.binding;
        this.eventName = prototype.eventName;
    }
    
    public create(view:View<any>,node:Node){
        this.element = <Element>node;
        this.eventListenner = this.executeEvent.bind(this);
        this.codeBehind = view;
        this.element.addEventListener(this.eventName,this.eventListenner);
    }

    private executeEvent(e){
        this.codeBehind[this.bindingPrototype.getSources()[0]](e);
    }
    public release(){
        this.element.removeEventListener(this.eventName,this.eventListenner);
    }
}